import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import HomePage from "./pages/home/HomePage";
import AOS from "aos";
import { ConnectionStatusProvider } from "./provider/ConnectionStatusProvider";
import DashboardPage from "./pages/stake/DashboardPage";
import TwitterGamePage from "./pages/twitter-game/TwitterGamePage";

const App: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <ConnectionStatusProvider>
      <Router>
        <div className="flex flex-col min-h-screen bg-body text-white">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/twitter-game" element={<TwitterGamePage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ConnectionStatusProvider>
  );
};

export default App;
